import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import config from './config'

Vue.use(Vueaxios, axios)
export default {
  getMenimumStock (body, success, error) {
    Vue.axios.post(config.baseURL + '/api/item/minimumStock', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  insertMinimumStock (body, success, error) {
    Vue.axios.post(config.baseURL + '/api/item/insertMinimumStock', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  },
  updateHoldBill (body, success, error) {
    Vue.axios.post(config.baseURL + '/api/sale/updateHoldBill', body).then(
      response => {
        success(response)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service_undefined.js